import base from '../dr-base'
import drToolbar from './dr-toolbar.vue'

const schema = {
  $Type: 'dr-toolbar',
  name: 'Toolbar',
  group: 'Menu widgets',
  icon: 'border-top',
  ...base,
  properties: {
    ...base.properties,
    Title: {
      name: 'vuetifyWidgets.dr-toolbar.title',
      type: 'string'
    },
    Color: {
      name: 'vuetifyWidgets.dr-toolbar.color',
      type: 'string',
      default: 'text',
      enum: [{
        value: 'primary',
        text: 'Primary'
      },{
        value: 'empty',
        text: 'Empty'
      },{
        value: 'accent',
        text: 'Accent'
      },{
        value: 'secondary',
        text: 'Secondary'
      }]
    },
    DarkMode: {
      name: 'vuetifyWidgets.dr-toolbar.darkMode',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-toolbar.active'
      },{
        value: false,
        text: 'vuetifyWidgets.dr-toolbar.notActive'
      }]
    },
    Collapse: {
      name: 'Collapse',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-toolbar.active'
      } ,{
        value: false,
        text: 'vuetifyWidgets.dr-toolbar.notActive'
      }]
    },
    Dense: {
      name: 'Dense',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-toolbar.active'
      } ,{
        value: false,
        text: 'vuetifyWidgets.dr-toolbar.notActive'
      }]
    },
    Extended: {
      name: 'Extended',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-toolbar.active'
      } ,{
        value: false,
        text: 'vuetifyWidgets.dr-toolbar.notActive'
      }]
    },
    Flat: {
      name: 'Flat',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-toolbar.active'
      } ,{
        value: false,
        text: 'vuetifyWidgets.dr-toolbar.notActive'
      }]
    },
    Prominent: {
      name: 'Prominent',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-toolbar.active'
      } ,{
        value: false,
        text: 'vuetifyWidgets.dr-toolbar.notActive'
      }]
    },
    Short: {
      name: 'Short',
      type: 'boolean',
      default: false,
      enum: [{
        value: true,
        text: 'vuetifyWidgets.dr-toolbar.active'
      } ,{
        value: false,
        text: 'vuetifyWidgets.dr-toolbar.notActive'
      }]
    },
    Widgets: {
      type: 'array'
    }
  }
}

export default {
  schema,
  component: drToolbar
}
